export enum ExpressOrderItemType {
  Product = 'product',
  Fee = 'fee',
}

export type ExpressOrderItem = {
  id: string;
  name: string;
  price: string;
  quantity: number;
  type: ExpressOrderItemType;
};

export type ExpressPaymentBreakdown = {
  shipping: string;
  tax: string;
  discount: string;
};

export type ExpressShippingMethod = {
  label: string;
  amount: string;
  identifier: string;
  detail: string;
};

export type ExpressPaymentData = {
  orderItems: ExpressOrderItem[];
  paymentBreakdown: ExpressPaymentBreakdown;
  paymentAmount: string;
};

export enum ExpressAuthorizeStatus {
  Error = 'error',
  Success = 'success',
  SuccessPendingConfirm = 'successPendingConfirm',
}

export type ExpressAuthorizeResult =
  | { status: ExpressAuthorizeStatus.Error }
  | { status: ExpressAuthorizeStatus.Success }
  | {
      status: ExpressAuthorizeStatus.SuccessPendingConfirm;
      paymentResponseToken?: string | null;
      thankYouPageUrl: string;
    };

export type ExpressContact = {
  countryCode?: string;
  city?: string;
  state?: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  addressLine1?: string;
  addressLine2?: string;
  postalCode?: string;
  phone?: string;
  email?: string;
};

export enum ExpressShippingError {
  AddressUnserviceable = 'SHIPPING_ADDRESS_UNSERVICEABLE',
}

export type ExpressPaymentAuthorized = {
  error?: unknown;
  detailsId?: string;
  billingContact?: ExpressContact;
  shippingContact?: ExpressContact;
};
